export default class MobileNavigation {

    constructor(elm) {

        elm.querySelector('.header-mobile__navigation-button').addEventListener('click', e => {
            e.preventDefault();
            if (!elm.querySelector('#mobile-navigation-main').classList.contains('active')) {
                elm.querySelector('#mobile-navigation-main').classList.add('active');
                elm.querySelector('.header-mobile__menu-icon.open').classList.remove('active');
                elm.querySelector('.header-mobile__menu-icon.close').classList.add('active');
                document.body.classList.add('stop-scrolling');

                if (document.querySelector('#nav-search-icon-mobile-close').classList.contains('active')) {
                    // close mobile search overlay
                    document.querySelector('.header').classList.remove('searching');
                    document.querySelector('.nav-search').classList.remove('searching');
                    document.querySelector('#nav-search-icon-mobile').classList.add('active');
                    document.querySelector('#nav-search-icon-mobile-close').classList.remove('active');
                    document.querySelector('.site-search').classList.remove('open');
                }

            } else {
                elm.querySelector('#mobile-navigation-main').classList.remove('active');
                elm.querySelector('.header-mobile__menu-icon.open').classList.add('active');
                elm.querySelector('.header-mobile__menu-icon.close').classList.remove('active');
                document.body.classList.remove('stop-scrolling');
            }
            elm.querySelector('.header-mobile__menu-text').classList.toggle('header-mobile__menu-text--active');
        });

        const elementsSub = elm.querySelectorAll('.nav-item.submenu');

        elementsSub.forEach(element => {

            element.querySelector('.dropdown-toggle').addEventListener('click', e => {
                e.preventDefault();
                element.querySelector('.header-mobile__navigation-container').classList.add('active');
                elm.querySelector('#mobile-navigation-main').classList.add('submenu-active');
            });
        });

        const elementsSubSub = elm.querySelectorAll('.nav-item.has-submenu');

        elementsSubSub.forEach(element => {

            element.querySelector('.nav-link').addEventListener('click', e => {
                e.preventDefault();
                element.nextElementSibling.classList.add('active');
                elm.querySelector('#mobile-navigation-main').classList.add('subsubmenu-active');

            });
        });

        const subElements = elm.querySelectorAll('.header-mobile__navigation-container.submenu');

        subElements.forEach(element => {
            element.querySelector('.header-mobile__backlink').addEventListener('click', e => {
                e.preventDefault();
                element.classList.remove('active');
                elm.querySelector('#mobile-navigation-main').classList.remove('submenu-active');
            });
        });
        const subSubElements = elm.querySelectorAll('.header-mobile__navigation-container.subsubmenu');

        subSubElements.forEach(element => {
            element.querySelector('.header-mobile__backlink').addEventListener('click', e => {
                e.preventDefault();
                element.classList.remove('active');
                elm.querySelector('#mobile-navigation-main').classList.remove('subsubmenu-active');
            });
        });

        elm.querySelector('.header-mobile__search').addEventListener('click', e => {
            e.preventDefault();
            elm.querySelector('.header-mobile__search-icon--close').classList.toggle('active');
            elm.querySelector('.header-mobile__search-icon').classList.toggle('active');
            elm.querySelector('.mobile-search').classList.toggle('active');
            document.body.classList.toggle('stop-scrolling');
        });
    }
}
